import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Report1 from "../components/reportModels/report1";
import Report2 from '../components/reportModels/report2';
import Report9 from '../components/reportModels/report9';
import Report10 from "../components/reportModels/report10";
import Report12 from '../components/reportModels/report12';
import Report25 from '../components/reportModels/report25';
import Report35 from '../components/reportModels/report35';
import Report15 from '../components/reportModels/report15';
import Report34 from '../components/reportModels/report34';
import Report8 from '../components/reportModels/report8';
import Report4 from '../components/reportModels/report4';
import Report6 from '../components/reportModels/report6';
import Report7 from '../components/reportModels/report7';
import Report45 from '../components/reportModels/report45';
import Report11 from '../components/reportModels/report11';
import Report19 from '../components/reportModels/report19';
import Report14 from '../components/reportModels/report14';
import Report30 from '../components/reportModels/report31';
import Report13 from '../components/reportModels/report13';
import Report31 from '../components/reportModels/report31';
import Report50 from '../components/reportModels/report50';


import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { getReportName } from '../utilities/functions';
import { useTranslate } from '../hooks/LanguageProvider';
import { bottom } from '@popperjs/core';
import Report27 from '../components/reportModels/report27';

interface ReportData {
  id_report: number;
  turn_report: number;
  date_creation: string;
  id_user: number;
  nom_user: string;
  prenom_user: string;
  date_debut: string;
  date_fin: string;
  PSN: string | null;
  immatriculation_vehicule: string | null;
  state_report: number;
  type_report: string;
  id_dispositif: number;
}


const Report: React.FC = () => {
  const { type_report } = useParams<{ type_report?: string }>();
  const { turn } = useParams<{ turn?: string }>();
  const { id_report } = useParams<{ id_report?: string }>();
  const { id_dispositif } = useParams<{ id_dispositif?: string }>();


  const [selectedReportsData, setSelectedReportsData] = useState<ReportData[]>([]);
  const { translate } = useTranslate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  const reportList = async (turn_report: number, id_dispositif: Number) => {
    try {
      const res = await fetch(
        `${backendUrl}/api/reports/byTurn/${turn_report}/${id_dispositif}`,
        { mode: "cors" }
      );

      if (!res.ok) {
        throw new Error(`Error retrieving reports for the tour. Status: ${res.status}`);
      }

      const data = await res.json();
      setSelectedReportsData(data);

      console.log(data)

    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {

    console.log(turn);
    console.log(id_dispositif);


    if (turn && id_dispositif) {
      const turnNumber = parseInt(turn);
      const idDispositif = parseInt(id_dispositif);

      if (!isNaN(turnNumber) && !isNaN(idDispositif)) {
        reportList(turnNumber, idDispositif);
      }
    }
  }, [turn, id_report]);;


  const renderReport = () => {
    switch (type_report) {
      case '1':
        return <Report1 id_report={id_report} turn={turn} type_report={type_report} />;
      case '2':
        return <Report2 id_report={id_report} turn={turn} type_report={type_report} />;
      case '4':
        return <Report4 id_report={id_report} turn={turn} type_report={type_report} />;
      case '6':
        return <Report6 id_report={id_report} turn={turn} type_report={type_report} />;
      case '7':
        return <Report7 id_report={id_report} turn={turn} type_report={type_report} />;
      case '8':
        return <Report8 id_report={id_report} turn={turn} type_report={type_report} />;
      case '9':
        return <Report9 id_report={id_report} turn={turn} type_report={type_report} />;
      case '10':
        return <Report10 id_report={id_report} turn={turn} type_report={type_report} />;
      case '11':
        return <Report11 id_report={id_report} turn={turn} type_report={type_report} />;
      case '12':
        return <Report12 id_report={id_report} turn={turn} type_report={type_report} />;
      case '13':
        return <Report13 id_report={id_report} turn={turn} type_report={type_report} />;
      case '14':
        return <Report14 id_report={id_report} turn={turn} type_report={type_report} />;
      case '15':
        return <Report15 id_report={id_report} turn={turn} type_report={type_report} />;
      case '19':
        return <Report19 id_report={id_report} turn={turn} type_report={type_report} />;
      case '25':
        return <Report25 id_report={id_report} turn={turn} type_report={type_report} />;
      case '27':
        return <Report27 id_report={id_report} turn={turn} type_report={type_report} />;
      case '28':
        return <Report1 id_report={id_report} turn={turn} type_report={type_report} />;
      case '29':
        return <Report1 id_report={id_report} turn={turn} type_report={type_report} />;
      case '30':
        return <Report30 id_report={id_report} turn={turn} type_report={type_report} />;
      case '31':
        return <Report31 id_report={id_report} turn={turn} type_report={type_report} />;
      case '32':
        return <Report1 id_report={id_report} turn={turn} type_report={type_report} />;
      case '33':
        return <Report1 id_report={id_report} turn={turn} type_report={type_report} />;
      case '34':
        return <Report34 id_report={id_report} turn={turn} type_report={type_report} />;
      case '35':
        return <Report35 id_report={id_report} turn={turn} type_report={type_report} />;
      case '36':
        return <Report1 id_report={id_report} turn={turn} type_report={type_report} />;
      case '45':
        return <Report45 id_report={id_report} turn={turn} type_report={type_report} />;
      case '50':
        return <Report50 id_report={id_report} turn={turn} type_report={type_report} />;
      default:
        return <div>No report found for this type_report {type_report}</div>;
    }
  };


  const navigate = useNavigate();
  const handleItemClick = (report: ReportData) => {

    navigate(`/report/${report.id_report}/${report.turn_report}/${report.type_report}/${report.id_dispositif}`);

  };


  return (
    <div id='main'>
      <div>

        <button
          className="btn btn-primary position-fixed end-0 z-3"
          style={{ top: '25%' }}
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#drawerMenu"
          aria-controls="drawerMenu"
        >
          <i className="las la-cog" style={{ fontSize: "24px" }}></i>
        </button>
        <div
          className="offcanvas offcanvas-end"
          tabIndex={-1}
          id="drawerMenu"
          aria-labelledby="drawerMenuLabel"
        >
          <div className="d-flex justify-content-between align-items-start p-4 border-bottom border-1 border-secondary position-relative"
            style={{
              cursor: 'pointer',
              padding: '4px',
              borderRadius: '6px',
              borderBottom: '1px solid #ddd !important'
            }}
          >

            <div>
              <h6 className="mb-1 fw-bold">Report List</h6>
              <p className="mb-0 text-muted small">View and manage all available reports</p>
            </div>

            {/* Actions : Refresh + Close */}
            <div className="d-flex align-items-center gap-2">
              {/* Refresh */}
              <div
                className="d-flex align-items-center gap-2"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  if (turn && id_dispositif) {
                    const turnNumber = parseInt(turn);
                    const idDispositif = parseInt(id_dispositif);
                    if (!isNaN(turnNumber) && !isNaN(idDispositif)) {
                      reportList(turnNumber, idDispositif);
                    }
                  }
                }}
              >
                <i className="las la-sync-alt"></i>
              </div>

              {/* Close */}
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary d-flex align-items-center"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              >
                <i className="las la-times"></i>
              </button>

            </div>
          </div>


          <div className="offcanvas-body">
            {selectedReportsData && selectedReportsData.length > 0 ? (
              <div>
                <h6>
                  {translate("Turn Report")}: {selectedReportsData[0].turn_report}
                </h6>
                {selectedReportsData.map((report: ReportData) => (
                  <div key={report.id_report}>
                    {report.state_report === 1 ? (
                      <a
                        href={`/report/${report.id_report}/${report.turn_report}/${report.type_report}/${report.id_dispositif}`}
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={(e) => {
                          e.preventDefault();
                          handleItemClick(report);
                        }}
                      >
                        [{report.type_report}] {getReportName(report.type_report, translate)}
                      </a>
                    ) : (
                      <span style={{ color: "gray" }}>
                        [{report.type_report}] {getReportName(report.type_report, translate)}
                      </span>
                    )}
                    <br />
                  </div>
                ))}
              </div>
            ) : (
              <p>No data available for selected turn report.</p>
            )}
          </div>
        </div>
      </div>
      {renderReport()}
    </div>
  );
};


export default Report;
